<template>
  <div class="row">
    <div class="col-md-12">
      <div class="category-top-bar">
        <div class="top-bar">
          <a class="btn btn-orange btn-icon back" :title="$t('general.back')" @click.prevent="goBack">
            <i class="ti-arrow-left"></i>
            {{ $t('general.back') }}
          </a>
        </div>
      </div>
      <p class="clearfix"></p>

      <div class="col-md-offset-1 col-md-10">
        <h4 class="purple text-center msub-page__title">
          {{ subscription ? subscription.name : $t('menuSubscriptions.newTitle') }}
        </h4>

        <!-- readiness: what is still missing before it can be sold -->
        <div v-if="subscription && subscription.issues && subscription.issues.length" class="msub-page__issues">
          <i class="fa fa-exclamation-triangle"></i>
          {{ $t('menuSubscriptions.notReady') }}: {{ issuesText(subscription.issues) }}
        </div>
        <div v-else-if="subscription" class="msub-page__ready">
          <i class="fa fa-check-circle"></i>
          {{ subscription.active ? $t('menuSubscriptions.readyActive') : $t('menuSubscriptions.readyInactive') }}
        </div>

        <div class="msub-tabs">
          <button v-for="tab in tabs"
                  :key="tab.key"
                  class="btn msub-tabs__btn"
                  :class="{ 'is-active': currentTab === tab.key }"
                  :disabled="tab.needsId && !subscriptionId"
                  :title="tab.needsId && !subscriptionId ? $t('menuSubscriptions.saveFirst') : ''"
                  @click="currentTab = tab.key">
            <i :class="tab.icon"></i> {{ $t(tab.label) }}
          </button>
        </div>

        <!-- general + delivery are one form (one save), shown per tab -->
        <menu-subscription-form v-show="currentTab === 'general' || currentTab === 'delivery'"
                                :subscription-id="subscriptionId"
                                :section="currentTab === 'delivery' ? 'delivery' : 'general'"
                                @loaded="onLoaded"
                                @saved="onSaved"></menu-subscription-form>

        <menu-subscription-menus v-if="subscriptionId && subscription && currentTab === 'menus'"
                                 :subscription="subscription"
                                 :assign-dates="pendingAssignDates"
                                 @changed="reloadSubscription"
                                 @assigned="onAssigned"></menu-subscription-menus>

        <menu-subscription-calendar v-if="subscriptionId && subscription && currentTab === 'calendar'"
                                    :subscription="subscription"
                                    @new-menu-for-dates="onNewMenuForDates"></menu-subscription-calendar>
      </div>
    </div>
  </div>
</template>
<script>
  import MenuSubscriptionForm from './MenuSubscriptionForm.vue'
  import MenuSubscriptionMenus from './MenuSubscriptionMenus.vue'
  import MenuSubscriptionCalendar from './MenuSubscriptionCalendar.vue'
  import { issuesText } from './menuSubscriptionHelpers'

  // used for both /marketing/menu-subscriptions/add and /marketing/menu-subscriptions/edit/:id
  export default {
    components: {
      MenuSubscriptionForm,
      MenuSubscriptionMenus,
      MenuSubscriptionCalendar
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      const id = this.route.params && this.route.params.id ? parseInt(this.route.params.id, 10) : null
      const tab = this.route.query && this.route.query.tab
      return {
        subscriptionId: id,
        subscription: null,
        currentTab: id && ['menus', 'calendar', 'delivery'].indexOf(tab) !== -1 ? tab : 'general',
        // dates picked in the calendar for a new menu: assigned after the menu is saved
        pendingAssignDates: [],
        tabs: [
          { key: 'general', label: 'menuSubscriptions.tabGeneral', icon: 'fa fa-info-circle', needsId: false },
          { key: 'delivery', label: 'menuSubscriptions.tabDelivery', icon: 'fa fa-truck', needsId: false },
          { key: 'menus', label: 'menuSubscriptions.tabMenus', icon: 'fa fa-list', needsId: true },
          { key: 'calendar', label: 'menuSubscriptions.tabCalendar', icon: 'fa fa-calendar', needsId: true }
        ]
      }
    },
    methods: {
      issuesText (issues) {
        return issuesText(this, issues)
      },
      onLoaded (data) {
        this.subscription = data
      },
      onSaved (data, created) {
        this.subscription = data
        this.subscriptionId = data.id
        this.$bus.$emit('refresh')
        if (created) {
          // next step: the menus
          this.currentTab = 'menus'
        }
      },
      reloadSubscription () {
        this.apiRequest('/menu-subscription/' + this.subscriptionId, 'GET', {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }, (response) => {
          if (response.status === true && response.data) {
            this.subscription = response.data
          }
        })
        this.$bus.$emit('refresh')
      },
      onNewMenuForDates (dates) {
        this.pendingAssignDates = dates.slice()
        this.currentTab = 'menus'
      },
      onAssigned () {
        this.pendingAssignDates = []
        this.currentTab = 'calendar'
      },
      goBack () {
        this.$bus.$emit('refresh')
        this.$bus.$emit('close-modal')
      }
    }
  }
</script>
<style>
  .msub-page__title {
    margin-top: 0;
  }
  .msub-page__issues {
    background: #fff8e1;
    border: 1px solid #ffe082;
    color: #8d6e00;
    border-radius: 6px;
    padding: 8px 12px;
    margin-bottom: 12px;
    font-size: 13px;
  }
  .msub-page__ready {
    background: #e8f5e9;
    border: 1px solid #c8e6c9;
    color: #2e7d32;
    border-radius: 6px;
    padding: 8px 12px;
    margin-bottom: 12px;
    font-size: 13px;
  }
  .msub-tabs {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 14px;
  }
  .msub-tabs__btn {
    background: #fff;
    color: #5e35b1;
    border: 1px solid #d1c4e9;
  }
  .msub-tabs__btn.is-active {
    background: #7e57c2;
    color: #fff;
    border-color: #7e57c2;
  }
  .msub-tabs__btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/MenuSubscriptions/MenuSubscriptionPage.vue